// extracted by mini-css-extract-plugin
export default {"send-feedback-iframe":"_b1158d99","sendFeedbackIframe":"_b1158d99"};